import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { CommonModule } from '@angular/common';
import 'zone.js';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';

@Component({
  selector: 'tusangaire-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    TranslateModule,
    HttpClientModule,
    NgxUiLoaderModule
  ],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'af-notification';
  constructor(
    public translate: TranslateService,
    private serviceWorker: ServiceWorkerRegister,
    private router: Router
  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    this.serviceWorker.publicApi();

  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        document.body.scrollTop = 0;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }
}
